import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const blogs = [
   {
    id: 3,
    image:
      "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=700&auto=format&fit=crop&q=80",
    date: "April 28, 2025",
    category: "NEWS",
    tag: "AI Innovation",
    title: "KGS Technology Group & HiView.ai Mark a Major AI Transformation Milestone with Supreme Industries",
    excerpt:
      "KGS Technology Group and HiView.ai have achieved a significant milestone with the successful launch of their first major AI-driven transformation project at Supreme Industries Ltd.",
  },
  {  
    id: 1,
    image:
      "https://images.unsplash.com/photo-1511578314322-379afb476865?w=700&auto=format&fit=crop&q=80",
    date: "March 15, 2025",
    category: "EVENT",
    tag: "Foundation Day",
    title: "18 Years of Growth, Innovation & Togetherness: KGS Technology Group Foundation Day",
    excerpt:
      "KGS Technology Group proudly celebrated its 18th Foundation Day, marking another milestone in its journey of growth, innovation, and excellence.",
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=700&auto=format&fit=crop&q=80",
    date: "April 02, 2025",
    category: "CULTURE",
    tag: "Cricket Match",
    title: "Strengthening Workplace Culture Through Cricket at KGS Technology Group",
    excerpt:
      "At KGS Technology Group, building a strong workplace culture goes beyond day-to-day operations — cricket has become an important part of that culture.",
  },
 
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.14 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } },
};

export default function BlogSection() {
  const navigate = useNavigate();
  return (
    <section className="w-full bg-white py-8 mb-20  overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="flex flex-col items-center text-center mb-14">
          <motion.div
            initial={{ opacity: 0, y: -12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45 }}
            className="mb-5"
          >
            <span className="inline-block px-6 py-2 rounded-full border border-gray-200 bg-gray-50 text-gray-500 text-xs font-semibold tracking-widest uppercase shadow-sm">
             New's &amp; Event's
            </span>
          </motion.div>

          {/* <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: 0.1 }}
            className="text-[2rem] sm:text-[2.6rem] font-extrabold text-gray-900 leading-tight"
          >
            Transforming <span className="text-orange-500">Businesses</span> Through
            <br />
            Software Innovation
          </motion.h2> */}
        </div>

        {/* Cards */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
        >
          {blogs.map((blog) => (
            <motion.article
              onClick={()=>{
                  navigate(`/blogDetails/${blog.id}`);
                  window.scrollTo({
                    top:0,
                    behavior:"smooth"
                  })
                }}
              key={blog.id}
              variants={cardVariants}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
              className="group cursor-pointer"
            >
              {/* Image */}
              <div className="relative rounded-2xl overflow-hidden mb-5">
                <motion.img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-60 object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {/* NEWS badge — bottom right of image */}
                {/* <div className="absolute bottom-0 right-0 bg-orange-500 text-white text-xs font-bold px-5 py-2.5 rounded-tl-xl tracking-widest uppercase">
                  {blog.category}
                </div> */}
              </div>

              {/* Meta */}
              {/* <p className="text-gray-400 text-[0.85rem] mb-2">{blog.date}</p> */}

              {/* Title */}
              <h3 className="text-gray-900 font-bold text-[1.08rem] leading-snug mb-3 group-hover:text-orange-500 transition-colors duration-200">
                {blog.title}
              </h3>

              {/* Read More */}
              <motion.button
                className="inline-flex items-center gap-1.5 text-gray-800 font-bold text-[0.93rem] group-hover:text-orange-500 transition-colors duration-200"
              >
                Read More
                <motion.span
                  className="inline-block"
                  initial={{ x: 0 }}
                  whileHover={{ x: 4 }}
                >
                  →
                </motion.span>
              </motion.button>
            </motion.article>
          ))}
        </motion.div>

      </div>
    </section>
  );
}